import React from 'react'
import cx from 'classnames'
import { DFBIButton } from '../button'
import styles from './video-card.module.scss'

export default function VideoCard({
  logo,
  button,
  asset,
  speaker,
  company,
  date,
  tags,
  source,
  length,
}) {
  return (
    <article className={cx(styles.details, styles.card)}>
      <header>
        <img {...logo} />
      </header>
      <ul className="dfbi-list type-dfbi-label list-reset">
        <li>
          <span>Speaker</span>
          <span aria-hidden />
          <span>{speaker}</span>
        </li>
        <li>
          <span>Company</span>
          <span aria-hidden />
          <span>{company}</span>
        </li>
        <li>
          <span>Date</span>
          <span aria-hidden />
          <span>{date}</span>
        </li>
        <li>
          <span>Tags</span>
          <span aria-hidden />
          <span>{tags}</span>
        </li>
        <li>
          <span>Source</span>
          <span aria-hidden />
          <span>{source}</span>
        </li>
        <li>
          <span>Length</span>
          <span aria-hidden />
          <span>{length}</span>
        </li>
      </ul>
      {!asset ? null : (
        <footer>
          <DFBIButton download fill href={asset}>
            {button}
          </DFBIButton>
        </footer>
      )}
    </article>
  )
}
